import { action } from "../common/Action"
import { EsercentiClient, UserDataDto, CompanyDataDto, CompanyDto, RegisterCompanyRequest } from "../generated";

const service = new EsercentiClient();

class EsercentiActions {
    @action
    async getEsercente() {
        return (await service.get())!;
    };
    @action
    async update(companyId: number, company: CompanyDataDto) {
        const result = await service.update(company, companyId);
        if (result) return { ...company, id: companyId } as CompanyDto;
        else return null;
    };
    @action
    add(company: CompanyDataDto, users: UserDataDto[]) {
        return service.add(new RegisterCompanyRequest({ company, users }));
    };
    @action
    esercenteExist(vatNumber: string) {
        return service.esercenteExist(vatNumber);
    };
}
export default new EsercentiActions();